var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "plug"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7268_165922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7268_165922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.4 19.1H12.6V17.75L16.2 14.15V9.49998H7.8V14.15L11.4 17.75V19.1ZM9.6 20.9V18.5L6 14.9V9.49998C6 9.00498 6.17625 8.58123 6.52875 8.22873C6.88125 7.87623 7.305 7.69998 7.8 7.69998H9.15L8.4 8.79998V4.09998H10.2V7.69998H13.8V4.09998H15.6V8.79998L14.85 7.69998H16.2C16.695 7.69998 17.1188 7.87623 17.4713 8.22873C17.8238 8.58123 18 9.00498 18 9.49998V14.9L14.4 18.5V20.9H9.6Z",
    fill: "#1F6CF9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.b5f3edb37096360a1e355779f3eb1ed9.svg";
export { ForwardRef as ReactComponent };